import React from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import GroupLinkFlashMessage from '~/FlashMessage/components/GroupLinkFlashMessage';

export const createGroupAddedFlashMessage = ({ group, text }: { group: UserProductGroup; text: string }) => {
	return <GroupLinkFlashMessage group={group} linkTitle={group.name} text={text} />;
};
